// Butonul "Mergi la website" de pe prima pagina.
// Se activeaza/dezactiveaza din /apanel (doc Firestore appSettings/openWebsiteButton -> { enabled: boolean }).
export const DEFAULT_OPEN_WEBSITE_BUTTON_ENABLED = false;
